import { apiPrivateAxios } from "../../axios";
import { IGeocodePlace } from "./types";

export const geocodingRequest = {
  getGeocodePlaces: (value: string): Promise<IGeocodePlace[]> =>
    apiPrivateAxios.get(`/geocoding/geocode?searchQuery=${value}`),
};

const geocodingRequestModule = { geocodingRequest };

export default geocodingRequestModule;
